var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workflow_component",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"title"},[_vm._v("Title")]),_c('div',{staticClass:"multiple"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"link input_1"}),_vm._v("\n                Fichiers\n                "),_c('div',{staticClass:"link output_1"})])]),_c('div',{staticClass:"description"})])
}]

export { render, staticRenderFns }